export enum StepMarkerType {
  REGULAR, COMPLETED, GOAL
}

export interface StepItemData {
  title?: string,
  details?: string
}

export interface StepItemProps {
  isActive?: boolean,
  markerType: StepMarkerType,
  stepId?: number
  stepTitle?: string
}

export interface StepsProps {
  activeId: number,
  id?: string,
  stepData?: StepItemData[]
}



// WEBPACK FOOTER //
// ./src/types/components/Steps.ts